import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { AddEditProductCategoriesComponent } from '../../../../../modals/rentals/add-edit-product-categories/add-edit-product-categories.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rental-product-categories',
  templateUrl: './rental-product-categories.component.html',
  styleUrls: ['./rental-product-categories.component.scss'],
})
export class RentalProductCategoriesComponent implements OnInit {
  @Input() messageService;
  public loading: boolean = false;
  public loadingConfig: boolean = false;
  public categories: any = [];
  public rentalConfig: any = {};

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    public modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.getRentalConfig();
    this.getCategories();
  }

  getRentalConfig() {
    this.loadingConfig = true;
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          this.rentalConfig = config;
          this.loadingConfig = false;
        },
        (err) => {
          this.loadingConfig = false;
        },
      );
  }

  getCategories() {
    this.loading = true;
    this.rentalsService
      .getRentalProductCategories(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.categories = res;
          console.log(res);
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  addCategory() {
    const modalRef = this.modalService.open(AddEditProductCategoriesComponent, {
      backdrop: 'static',
      size: 'lg',
    });
    modalRef.componentInstance.category = {};
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.allowSecurityDeposit =
      this.rentalConfig.deductSecurityDeposit;
    modalRef.result.then((result) => {
      this.getCategories();
    });
  }

  editCategory(category) {
    const modalRef = this.modalService.open(AddEditProductCategoriesComponent, {
      backdrop: 'static',
      size: 'lg',
    });
    modalRef.componentInstance.category = category;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.allowSecurityDeposit =
      this.rentalConfig.deductSecurityDeposit;
    modalRef.result.then((result) => {
      this.getCategories();
    });
  }
}
